export default __webpack_public_path__ + "static/media/gaming.f72a6765.png";